import { useEffect, useState } from "react";

/** Navbar slots (always rendered, empty on v1 pages). */
export const TOPBAR_SLOT_ID = "topbar-slot";
export const TOPBAR_AGENT_SLOT_ID = "topbar-agent-slot";
/** Dispatch on `window` to open the advisor panel from a page button. */
export const OPEN_ADVISOR_EVENT = "gb:open-advisor";

/** The slot element, looked up after commit (same idiom as `#advisor-slot`). */
export function useTopBarSlot(id: string): Element | null {
  const [el, setEl] = useState<Element | null>(null);
  useEffect(() => {
    setEl(document.getElementById(id));
  }, [id]);
  return el;
}
